define.alias("ember-truth-helpers/helpers/or", "calendar/helpers/or");